import Vue from "vue";
import App from "./App";
import Axios from "axios";
import VueRouter from "vue-router";
import BootstrapVue from "bootstrap-vue";
import { routes } from "./routes";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Axios);

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: "history"
});

new Vue({
  el: "#app",
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js